<template>
  <div class="menu-form">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <b-card
            header-tag="header"
            footer-tag="footer">
            <div slot="header">
              <i className="fa fa-align-justify"></i><strong>{{ $t('user.profile') }}</strong>
            </div>
            <b-form class="row">
              <b-col cols="6">
                <b-form-group v-bind:label="$t('user.name')" :label-cols="3" :horizontal="true">
                  <b-form-input
                    class="form-control"
                    v-model="profile.name"
                    :state="!$v.profile.name.$invalid"
                    :aria-describedby="'name-feedback'" />
                  <b-form-invalid-feedback :id="'name-feedback'">
                    {{ $t('message.required_filed') }}
                  </b-form-invalid-feedback>
                </b-form-group>

                <b-form-group v-bind:label="$t('user.email')" :label-cols="3" :horizontal="true">
                  <b-form-input class="form-control"
                                v-model="profile.email" disabled />
                </b-form-group>

              </b-col>

            </b-form>
            <div slot="footer">
              <div class="text-center">
                <button class="btn float-right bg-main border-radius-4px" v-on:click="updateProfile()" :disabled="checkProfileSubmit()" ><i class="fa fa-arrow-right"></i>&nbsp; {{$t('common.save')}}</button>
              </div>
            </div>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <b-card
            header-tag="header"
            footer-tag="footer">
            <div slot="header">
              <i className="fa fa-align-justify"></i><strong>{{ $t('user.change_password') }}</strong>
            </div>
            <b-form class="row">
              <b-col cols="6">
                <b-form-group v-bind:label="$t('user.old_password')" :label-cols="4" :horizontal="true">
                  <b-form-input
                    class="form-control"
                    v-model="password.old_password"
                    type="password"
                    required />
                </b-form-group>

                <b-form-group v-bind:label="$t('user.new_password')" :label-cols="4" :horizontal="true">
                  <b-form-input
                    class="form-control"
                    v-model="password.new_password"
                    type="password"
                    :state="!$v.password.new_password.$invalid"
                    :aria-describedby="'new_password-feedback'"
                  />
                  <div class="xs-flex xs-items-center xs-mb-5">
                    <span class="text-alert">{{$t('register.password_condition')}}</span>
                  </div>
                  <div class="xs-flex xs-items-center xs-mb-5" v-for="passwordValid in passwordValidation">
                    <i class="fa" v-bind:class="{ 'fa-times xs-text-red': (passwordValid.status === 0), 'fa-check xs-text-green-dark': (passwordValid.status === 1), 'fa-times xs-text-gray': (passwordValid.status === 2)}"
                       v-bind:key="passwordValid.message" />
                    <div class="typo-l7"
                         v-bind:class="{ 'xs-text-red': (passwordValid.status === 0), 'xs-text-green-dark': (passwordValid.status === 1), 'xs-text-gray': (passwordValid.status === 2)}"
                         v-bind:key="passwordValid.message">
                      <span>{{passwordValid.message}}</span>
                    </div>
                  </div>
                  <div class="xs-flex xs-items-center xs-mb-5">
                    <span class="text-alert">{{$t('register.password_condition_infomation')}}</span>
                  </div>
                </b-form-group>

                <b-form-group v-bind:label="$t('user.confirm_new_password')" :label-cols="4" :horizontal="true">
                  <b-form-input
                    class="form-control"
                    v-model="password.confirm_password"
                    type="password"
                  />
                </b-form-group>

              </b-col>

            </b-form>
            <div slot="footer">
              <div class="text-center">
                <button class="btn float-right bg-main border-radius-4px" v-on:click="changePassword()" :disabled="checkPasswordSubmit()" ><i class="fa fa-arrow-right"></i>&nbsp; {{$t('common.save')}}</button>
              </div>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
  import {validationMixin} from 'vuelidate'
  import {required, minLength, sameAs } from 'vuelidate/lib/validators'
  import cSwitch from '../../../components/Switch'
  import Tables from '../../tables/Tables'
  let vm = null
  const PASSWORD_MIN = 8

  export default {
    name: 'Profile',
    props: {
      uuid: {
        type: String
      }
    },
    components: {
      Tables,
      cSwitch
    },
    data: function () {
      return {
        profile: {
          name: '',
          email: '',
          uuid: ''
        },
        password: {
          old_password: '',
          new_password: '',
          confirm_password: ''
        },
        passwordValidation: []
      }
    },
    mixins: [
      validationMixin
    ],
    validations: {
      profile: {
        name: {
          required
        }
      },
      password: {
        old_password: {
          required
        },
        new_password: {
          required,
          strongPassword (password) {
            let validationResult = []
            let count = 0
            this.passwordValidation = this.passwordValidation.map((rule) => {
              if (rule.regex.test(password)) {
                rule.status = 1
                validationResult.push(rule.status)
                count++
              } else {
                rule.status = 0
                validationResult.push(rule.status)
              }
              return rule
            })
            this.passwordValidation.forEach((item) => {
              if (!item.status && count === 3) {
                item.status = 2
              }
            })
            return (count > 2 && password.length >= PASSWORD_MIN)
          }
        },
        confirm_password: {
          sameAsPassword: sameAs('new_password')
        }
      }
    },
    methods: {
      checkProfileSubmit: function(){
        return vm.$v.profile.$invalid
      },
      checkPasswordSubmit: function() {
        console.log(vm.$v.password.$invalid)
        return vm.$v.password.$invalid
      },
      isJSON: function(str) {
        try {
          JSON.parse(str)
        } catch (e) {
          return false
        }
        return true
      },
      updateProfile: function () {
        vm.axios.user.updateMe('', {'name': vm.profile.name}, respone => {
          window.location.reload()
        }, error => {
          console.log('error', error)
        })
      },
      changePassword: function () {
        let passwordData = {
          'old_password': vm.password.old_password,
          'password': vm.password.new_password,
          'password_confirmation': vm.password.confirm_password
        }
        vm.axios.user.updateMe('', passwordData, respone => {
          if (localStorage.getItem('default_auth_token') === null) {
            this.$router.push('login')
            return
          }
          this.$Progress.start()
          this.$auth.logout({
            makeRequest: true,
            success: function (response) {
              this.$Progress.finish()
            },
            error: function (error) {
              this.$Progress.fail()
              console.log(error)
            },
            redirect: '/login'
          })

        }, error => {
          console.log('error', error)
        })
      }
    },
    mounted: function () {
      this.passwordValidation = [
        {
          status: 0,
          message: this.$t('validate_password_no_uppercase'),
          regex: /[A-Z]/
        },
        {
          status: 0,
          message: this.$t('validate_password_no_lowercase'),
          regex: /[a-z]/
        },
        {
          status: 0,
          message: this.$t('validate_password_no_number'),
          regex: /[0-9]/
        },
        {
          status: 0,
          message: this.$t('validate_password_no_non_alphanumberic'),
          regex: /[^a-zA-Z\d\s:]/
        }
      ]
    },
    created: function () {
      vm = this
      // get user detail
      vm.axios.user.getMe('', respone => {
        if (respone.status === 200) {
          let user = respone.data.data.item
          vm.profile.uuid = user.uuid
          vm.profile.name = user.name
          vm.profile.email = user.email
        }
      }, error => {
        console.log('error', error)
      })
    }
  }
</script>

<style scoped>
  .input-group-text .custom-checkbox {
    margin-right: 0px;
    padding-left: 1.0rem;
  }

  .input-group-text {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    padding: 0.375rem 0.75rem;
    margin-bottom: 0;
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.5;
    color: #3e515b;
    text-align: center;
    white-space: nowrap;
    background-color: #f8f9fa;
    border: 1px solid #e4e5e6;
  }

  .custom-checkbox {
    padding-left: 0px;
  }

  .col-6{
    float: left;
  }

  .menu-form .card-footer {
    margin-left: 0 !important;
    text-align: right;
    position: inherit !important;
  }
  .xs-flex i {
     float: left;
     margin-right: 5px;
   }
  .text-alert {
    font-size: 80%;
  }
  .typo-l7 {
    font-size: 80%;
  }
  .xs-text-green-dark {
    color: #00a67c;
  }
  .xs-text-red {
    color: red;
  }
  .xs-text-gray {
    color: #999580;
  }
</style>



// WEBPACK FOOTER //
// src/views/admin/user/Profile.vue